import React from 'react'
import { Link } from 'react-router-dom'

/**
 * Refund Policy — scaffold awaiting real generator-based content.
 *
 * Section headings below match the structure most generators produce
 * (Termly, GetTerms, etc.) so dropping in real copy is a per-section
 * paste, not a restructure. Bodies are intentionally empty pending
 * legal review.
 */

const sectionStyle: React.CSSProperties = {
  marginBottom: 28,
}
const h2Style: React.CSSProperties = {
  fontSize: 18, fontWeight: 700, color: 'var(--ink-primary)',
  margin: '0 0 10px', letterSpacing: '-0.01em',
}
const pStyle: React.CSSProperties = {
  fontSize: 15, color: 'var(--ink-secondary)', lineHeight: 1.7, margin: 0,
}

export default function Refund() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--canvas)', color: 'var(--ink-primary)', padding: '48px 24px' }}>
      <div style={{ maxWidth: 720, margin: '0 auto' }}>
        <Link to="/" style={{ fontSize: 13, color: 'var(--ink-tertiary)', textDecoration: 'none' }}>← Back to home</Link>

        <h1 style={{ fontSize: 36, fontWeight: 900, letterSpacing: '-0.03em', margin: '20px 0 8px' }}>Refund Policy</h1>
        <p style={{ fontSize: 13, color: 'var(--ink-tertiary)', margin: '0 0 24px' }}>Last updated: —</p>

        {/* Interim notice — replaces "being finalized" stub. */}
        <div style={{ padding: '14px 16px', background: 'var(--accent-dim)', border: '1px solid var(--accent-border)', borderRadius: 12, marginBottom: 32 }}>
          <p style={{ fontSize: 13, color: 'var(--ink-secondary)', margin: 0, lineHeight: 1.6 }}>
            This policy is under active revision before public launch. Soft-launch users: please reach out with questions at{' '}
            <a href="mailto:hello@orkestrapro.com" style={{ color: 'var(--accent-text)', textDecoration: 'none', fontWeight: 600 }}>hello@orkestrapro.com</a>.
          </p>
        </div>

        <div style={sectionStyle}>
          <h2 style={h2Style}>1. Free Trial</h2>
          <p style={pStyle}>{/* Generator content goes here. */}</p>
        </div>

        <div style={sectionStyle}>
          <h2 style={h2Style}>2. Subscription Refunds</h2>
          <p style={pStyle}>{/* Generator content goes here. */}</p>
        </div>

        <div style={sectionStyle}>
          <h2 style={h2Style}>3. Cancellation</h2>
          <p style={pStyle}>{/* Generator content goes here. */}</p>
        </div>

        <div style={sectionStyle}>
          <h2 style={h2Style}>4. How to Request a Refund</h2>
          <p style={pStyle}>{/* Generator content goes here. */}</p>
        </div>

        <div style={sectionStyle}>
          <h2 style={h2Style}>5. Exceptions</h2>
          <p style={pStyle}>{/* Generator content goes here. */}</p>
        </div>

        <div style={sectionStyle}>
          <h2 style={h2Style}>6. Contact</h2>
          <p style={pStyle}>
            Questions about refunds or cancellations can be sent to{' '}
            <a href="mailto:hello@orkestrapro.com" style={{ color: 'var(--accent-text)', textDecoration: 'none' }}>hello@orkestrapro.com</a>.
          </p>
        </div>
      </div>
    </div>
  )
}
